import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMv = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 720 480", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#D21034", d: "M0 0h720v480H0z" }), /* @__PURE__ */ React.createElement("g", { fill: "#007E3A" }, /* @__PURE__ */ React.createElement("path", { d: "M120 120h480v240H120z" }), /* @__PURE__ */ React.createElement("circle", { fill: "#FFF", cx: 390, cy: 240, r: 80 }), /* @__PURE__ */ React.createElement("circle", { cx: 420, cy: 240, r: 80 })));
const ForwardRef = forwardRef(SvgMv);
const Memo = memo(ForwardRef);
export default Memo;
